import type { Labels } from "./types";

/**
 * Safely get a label by dot path with fallback to the key itself.
 *
 * Client-safe: this module imports no locale files. Use it in client components to read a
 * label by a dynamic key without errors when the key is missing.
 *
 * Usage:
 *   const labels = useLabels();
 *   const text = getLabel(labels, "matchPage.lineups.substitutes"); // translated value or the key
 */
export function getLabel(labels: Labels, key: string): string {
    const value = getNestedValue(labels as unknown as Record<string, unknown>, key);
    if (value === undefined) {
        console.warn(`Missing label: ${key}`);
        return key;
    }
    return value;
}

function getNestedValue(obj: Record<string, unknown>, path: string): string | undefined {
    const result = path.split(".").reduce<unknown>((o, k) => (o as Record<string, unknown> | undefined)?.[k], obj);
    return typeof result === "string" ? result : undefined;
}
